import { Actions } from "../../components/buttons/Actions";
import { actionsColumn, createdColumn } from "../../constants/objects";
import { ROLES, VIEW } from "../../constants/strings";
import { useAppContext } from "../../context/useAppContext";
import { FormLayoutHandler } from "../../pages/layouts/FormLayoutHandler";
import { dateTimeFormat } from "../../utils/formatter";

export const useRoles = () => {
  const { contextData } = useAppContext();

  const tableData = (data) => [
    ...data.map((item) => {
      const { timestamp, name } = item || {};
      const row = {
        name,
        timestamp: dateTimeFormat(timestamp),
        actions: <Actions actions={[{ action: VIEW }]} />,
        onclick: () =>
          contextData.showGlobalDrawer({
            component: (
              <FormLayoutHandler key={ROLES} source={ROLES} data={item} />
            ),
            title: "Update Role",
          }),
      };
      return row;
    }),
  ];

  const tableColumns = () => [
    { id: "name", title: "Role Name", align: "left" },
    createdColumn,
    actionsColumn,
  ];

  const form = {
    source: ROLES,
  };

  return { tableColumns, tableData, form };
};
